import React, { useEffect, useState } from 'react';
import { dateToLocal, handleError, handleErrorToast } from '../shared/Functions';
import { AutoPaysVService } from '../../services/V2/gozer/services/AutoPaysVService';
import GetAppIcon from '@material-ui/icons/GetApp';
import { getAutoPayments } from '../shared/ExportFunctions';
import { useParams } from 'react-router';
import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@material-ui/icons/Remove';
import SendIcon from '@material-ui/icons/Send';
import LoopIcon from '@material-ui/icons/Loop';
import { DistrictsVService } from '../../services/V2/padre';
import { authProvider } from '../../services/Security';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';
import { CustomTable } from '../shared/CustomTable';

export const AutoPayments = ({ errorToast, successToast }) => {
    const { paymentId } = useParams<{ paymentId: string }>();

    const [connection, setConnection] = useState<any>(null);
    const [payments, setPayments] = useState<any>();
    const [district, setDistrict] = useState<any>();
    const [disablePayments, setDisablePayments] = useState<boolean>(false);
    const [isOnReRunPayments, setIsOnReRunPayments] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>();
    const [loading, setLoading] = useState<boolean>(true);

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token);
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        AutoPaysVService.autoPaysVGetById(paymentId)
            .then((x: any) => {
                setPayments(x)
                setDisablePayments(x.hasBeenRerun)
                DistrictsVService.districtsVGetById(x.districtId)
                    .then((x) => {
                        setDistrict(x)
                    }).catch(x => {
                        errorToast(handleErrorToast(x))
                    })
            }).catch(x => {
                errorToast(handleErrorToast(x))
            })
    }, [paymentId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl(`${process.env.GOZER_HOST}/hub/RecurringPayments`, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets
            })
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    useEffect(() => {
        setTableData(payments?.paymentResults?.results)
        setIsOnReRunPayments(false)
    }, [payments])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(result => {
                    connection.on('RecurringMessage', message => {
                        var data = message
                        if (data.districtId !== district.id) return;
                        if (!data) errorToast("Something Failed")
                        else if (!data.id) errorToast(data.message)
                        else {
                            successToast(`Success! ${data.successes} succeeded, ${data.failures} failed.`)
                            setDisablePayments(false)
                            setPayments(data)
                        }
                    });
                })
                .catch(e => console.log('Connection failed: ', e));
        }
    }, [connection]);// eslint-disable-line react-hooks/exhaustive-deps

    const rerunAutoPay = () => {
        let confirm = window.confirm(`Are you sure you want to rerun Recurring Payments for all failed Billing Account payments for ${district?.name}?`);

        if (confirm === true) {
            setDisablePayments(true)
            AutoPaysVService.autoPaysVRerunFailedPayments(paymentId)
                .then(x => {
                    setDisablePayments(false)
                    successToast(`Running. You can leave the page and come back for results or wait here and be redirected once they come in.`)
                })
                .catch(x => errorToast(handleErrorToast(x)))
        }
    }

    const handleDownload = (id, date) => {
        getAutoPayments(id, date)
            .then(x => console.log(x))
            .catch(err => handleError(err))
    }

    return (
        <React.Fragment>
            <CustomTable
                title={`Payments from ${payments?.runDate && dateToLocal(payments?.runDate).toLocaleString()}. BatchId: ${payments?.batchId}`}
                columns={[
                    { title: 'BillingAccountId', field: 'billingAccountId', editable: 'never' },
                    { title: 'Error Details', field: 'errorDetails', editable: 'never' },
                    { title: 'Payment Amount', field: 'paymentAmount', editable: 'never' },
                    { title: 'Approved', field: 'paymentDetails.resultCode', editable: 'never', render: (rowData: any) => rowData.paymentDetails?.resultCode === "Approved" ? <CheckIcon /> : <RemoveIcon /> },
                    { title: 'Approval Code', field: 'paymentDetails.transaction.approvalCode', editable: 'never', render: (rowData: any) => rowData.paymentDetails?.transaction?.approvalCode },
                ]}
                dataSet={tableData ?? []}
                actions={[
                    {
                        icon: () => <SendIcon />,
                        tooltip: "ReSubmit Failed Payments",
                        isFreeAction: true,
                        onClick: () => rerunAutoPay(),
                        disabled: disablePayments || payments?.hasBeenRerun || payments?.failures === 0
                    },
                    {
                        icon: () => <GetAppIcon />,
                        tooltip: "Export",
                        isFreeAction: true,
                        onClick: () => handleDownload(paymentId, dateToLocal(payments?.createdAt).toLocaleString())
                    },
                    {
                        icon: () => <LoopIcon />,
                        tooltip: "Toggle ReSubmitted Payments",
                        isFreeAction: true,
                        onClick: () => {
                            if (isOnReRunPayments) setTableData(payments?.paymentResults?.results);
                            else setTableData(payments?.reRunPaymentResults?.results);
                            setIsOnReRunPayments(!isOnReRunPayments);
                        },
                        disabled: !payments?.hasBeenRerun
                    }
                ]}
                refresh={loading} setRefresh={setLoading} pageSize={15} enablePaging={true}
                districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }} hiddenColumnsDisabled={true}
                tableHeight={"400px"} enableSearch={false} searchPlaceholder={null} dataEndpoint={undefined}
            />
        </React.Fragment>
    );
}
